import {IStateKpi} from '../../../api/analyticsKPI/types';

export const selectAnalyticsKpi = (state: IStateKpi) => state.analyticsKpi.data;
